export const ActiveAnalysis = {
  currentAnalysisId : null,
  previousAnalysisId: null,
  isDraft: false
}
